import { supabase } from '../supabaseClient'

export const FEATURE_KEYS = {
  PREMIUM_ENABLED: 'premium_enabled',
  UNLIMITED_KEYWORDS: 'unlimited_keywords',
  MANUAL_DAILY_SEARCH: 'manual_daily_search',
}

const asEnabled = (flags, key) => flags?.[key] === true

export const resolveUserFeatures = (flags = {}) => {
  const premiumEnabled = asEnabled(flags, FEATURE_KEYS.PREMIUM_ENABLED)

  return {
    premium_enabled: premiumEnabled,
    unlimited_keywords: premiumEnabled && asEnabled(flags, FEATURE_KEYS.UNLIMITED_KEYWORDS),
    manual_daily_search: premiumEnabled && asEnabled(flags, FEATURE_KEYS.MANUAL_DAILY_SEARCH),
  }
}

export const hasFeature = (features, featureKey) => {
  if (!features || !featureKey) return false
  return features[featureKey] === true
}

export const getUserFeatures = async (userId) => {
  if (!userId) return resolveUserFeatures({})

  const { data, error } = await supabase
    .from('feature_flags')
    .select('feature, enabled')
    .eq('user_id', userId)
    .in('feature', [
      FEATURE_KEYS.PREMIUM_ENABLED,
      FEATURE_KEYS.UNLIMITED_KEYWORDS,
      FEATURE_KEYS.MANUAL_DAILY_SEARCH,
    ])

  if (error) throw error

  const flags = (data || []).reduce((acc, row) => {
    acc[row.feature] = row.enabled === true
    return acc
  }, {})

  return resolveUserFeatures(flags)
}

export const getKeywordLimit = (features) => (hasFeature(features, 'unlimited_keywords') ? null : 3)

export const clampKeywords = (keywords, features) => {
  const list = Array.isArray(keywords) ? keywords.filter(Boolean) : []
  const limit = getKeywordLimit(features)
  if (limit === null) return list
  return list.slice(0, limit)
}
